<app-card align="center" [hidHeader]="false" [options]="false">
    <img src="assets/images/tabela.png" alt="" >
</app-card>
